import React from 'react';
import './ValidationDialog.css';

const ValidationDialog = ({ isOpen, message, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog-content validation-dialog" onClick={e => e.stopPropagation()}>
        <div className="dialog-header">
          <h3>PixlSizer</h3>
        </div>
        <div className="dialog-body">
          <div className="validation-icon">⚠️</div>
          <p className="validation-message">{message}</p>
        </div>
        <div className="dialog-actions">
          <button className="glass-button" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default ValidationDialog;